<template>
  <BaseLayoutApp>
    <div class="help">
      <BaseNavSecondary :paths="['/help/guides', '/help/contact']" />
      <router-view />
    </div>
  </BaseLayoutApp>
</template>

<script>
import BaseLayoutApp from '@/components/BaseLayoutApp/BaseLayoutApp'
import BaseNavSecondary from '@/components/BaseNavSecondary/BaseNavSecondary'
export default {
  components: {
    BaseLayoutApp,
    BaseNavSecondary
  }
}
</script>

<style lang="scss" scoped>
.help {
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  grid-gap: var(--spacing-5);
}
</style>
